import(/* webpackMode: "eager" */ "/home/runner/work/kst-frontend/kst-frontend/app/customer-registration/ClientCustomerRegistration.tsx")